module.exports = __webpack_public_path__ + "static/media/tartine-home-small.896879ce.png";